<div *ngIf="isEnabled">
	<mat-form-field
		#popoverTrigger="mtxPopoverTrigger"
		(click)="
			$event.stopPropagation();
			customersList.length == 0 ? loadInitialCustomersList() : null;
			focusToSearchInput()
		"
		[mtxPopoverTriggerFor]="customerPopover"
		class="{{ customFormFieldClass }}"
		floatLabel="never"
		fxFlex
		mtxPopoverTriggerOn="click"
	>
		<mat-label [ngClass]="{ 'primary-text': placeholder !== 'Customer Name' }" class="capitalize">{{
			placeholder
		}}</mat-label>
		<input matInput readonly="true" />
		<mat-icon *ngIf="renderDownArrowIcon()" class="vertical-align-middle" matSuffix
			>keyboard_arrow_down
		</mat-icon>
		<mat-icon
			(click)="$event.stopPropagation(); removeSelectedCustomer()"
			*ngIf="renderCloseArrowIcon()"
			class="vertical-align-middle danger-text cursor-pointer"
			matSuffix
		>
			close
		</mat-icon>
	</mat-form-field>

	<mtx-popover [closeOnPanelClick]="false" #customerPopover="mtxPopover">
		<mat-card class="p-0 primary-border">
			<mat-card-content class="customers-dropdown font-size-14 p-b-2">
				<div class="padding-0-5" fxLayout="row">
					<mat-form-field fxFlex>
						<input
							#searchInput
							(input)="inputChanged($event.target.value)"
							[(ngModel)]="searchText"
							autocomplete="off"
							class="capitalize"
							matInput
							placeholder="Type to filter"
						/>
					</mat-form-field>
				</div>
				<div *ngIf="isLoadingCustomersList" class="padding-0-5" fxLayout="row">
					<div fxFlex fxLayoutAlign="center center">
						<mat-spinner [diameter]="11"></mat-spinner>
					</div>
				</div>

				<div *ngIf="!isMultiselect">
					<div
						(click)="setSelectedCustomer(customer)"
						*ngFor="let customer of customersList"
						class="padding-0-5 customer-row cursor-pointer"
						fxLayout="row"
					>
						<div class="primary-text capitalize" fxFlex fxLayoutAlign="start center">
							{{ customer.name }}
							<span *ngIf="showCustomerCode && IS_NOT_EMPTY(customer.customerCode)"
								>&nbsp;({{ customer.customerCode }})</span
							>
						</div>
					</div>
				</div>

				<div *ngIf="isMultiselect">
					<div class="padding-0-5 p-t-0">
						<span (click)="clearMultiSelection()" class="link">Clear Selection</span>
					</div>

					<div
						*ngFor="let customer of customersList"
						class="padding-0-5 customer-row cursor-pointer"
						fxLayout="row"
					>
						<div class="primary-text capitalize" fxFlex fxLayoutAlign="start center">
							<mat-checkbox
								(change)="handleMultiselect(customer, customer.checked)"
								[(ngModel)]="customer.checked"
								[color]="'primary'"
								[disabled]="false"
								[labelPosition]="'after'"
								class="fs-13"
							>
								{{ customer.name
								}}<span *ngIf="showCustomerCode && IS_NOT_EMPTY(customer.customerCode)"
									>&nbsp;({{ customer.customerCode }})</span
								>
							</mat-checkbox>
						</div>
					</div>
				</div>

				<div
					*ngIf="!isLoadingCustomersList && searchText.length > 0 && customersList.length === 0"
					class="padding-0-5 customer-row"
				>
					<div (click)="addCustomer()" class="link" fxFlex fxLayoutAlign="center center">
						Add New Customer
					</div>
				</div>
			</mat-card-content>
		</mat-card>
	</mtx-popover>
</div>
<div *ngIf="!isEnabled" fxFlex>
	<mat-form-field
		*ngIf="!isEnabled"
		[matTooltip]="disabledTooltipMessage"
		class="custom-form-field"
		floatLabel="never"
		fxFlex
		matTooltipClass="custom-tooltip"
		class="{{ customFormFieldClass }}"
	>
		<mat-label class="secondary-text-color">{{ placeholder }}</mat-label>
		<input matInput readonly="true" />
		<mat-icon class="vertical-align-middle secondary-text-color" matSuffix
			>keyboard_arrow_down
		</mat-icon>
	</mat-form-field>
</div>
